<template>
	<v-header title="确认登记预约" headerLeftStatus="true" />
	<div class="sysMain">
		<div class="sysMainBody">
			<Card style="width:100%; margin-bottom:10px;">
				<template #title>
					预约时间 {{converterEx.toDateString(model.RegisterDate)+" "+model.RegisterTime }}
				</template>
				<Form ref="form" :model="model" :rules="ruleValidate" :label-width="80">
					<FormItem label="描述">
						<Row>
							<Col flex="auto" style="color: #8C8C8C; ">填写预约人信息</Col>
							<Col flex="60px"><Button @click="showDrawerUser()">选择</Button></Col>
						</Row>
					</FormItem>
					<FormItem label="姓名" prop="PatientName">
						<Input v-model="model.PatientName" placeholder="请输入"></Input>
					</FormItem>
					<FormItem label="证件类型" prop="IDCardType">
						<Select v-model="model.IDCardType">
							<Option v-for="cardType in view.iDCardType" :value="cardType.value" :key="cardType.value">
								{{ cardType.value }}
							</Option>
						</Select>
					</FormItem>
					<FormItem label="证件号" prop="IDCardNo">
						<Input v-model="model.IDCardNo" placeholder="请输入"></Input>
					</FormItem>
					<FormItem label="电话" prop="PatientPhone">
						<Input v-model="model.PatientPhone" placeholder="请输入"></Input>
					</FormItem>
					<FormItem label="性别" prop="Sex">
						<RadioGroup v-model="model.Sex">
							<Radio label='男' style="margin-right: 50px;margin-left: 10px;">男</Radio>
							<Radio label='女'>女</Radio>
						</RadioGroup>
					</FormItem>
					<FormItem label="生日" prop="Birthday">
						<DatePicker type="date" v-model="model.Birthday" placeholder="选择体" style="width: 100%;" />
					</FormItem>
					<FormItem label="健康顾问" >
						<Input v-model="model.Consultant" placeholder="请输入"></Input>
					</FormItem>
				</Form>
			</Card>
			<div style="text-align:center">
				<Button type="primary" @click="confirm()">保存</Button>
			</div>
			<Drawer title="选择家人" placement="bottom" :mask-closable="false" height="80%" v-model="view.showDrawerUser">
				<List size="small" class="suiteMain">
					<ListItem v-for="item in userList">
						<ListItemMeta :title="item.patientName" @click="userCheck(item)" />
						<template #action>
							<li>
								<span>{{item.sex}}</span>
							</li>
						</template>
					</ListItem>
				</List>
			</Drawer>
			<Modal
			        v-model="view.showPrompt"
			        title="预约体检提示"
			        @on-ok="post">
					<p v-html="view.promptContent"></p>
			    </Modal>
		</div>
		<div style="text-align:center" v-show="view.noData===true">
			<Result type="warning" title="" desc="没有相关数据"></Result>
		</div>
	</div>
</template>

<script>
	import header from "@/components/header/index";
	import {
		getToken,
	} from '@/utils/auth'
	import {
		sysPost
	} from '@/utils/api'
	export default {
		name: 'center',
		data() {
			return {
				view: {
					iDCardType: [{
							value: '身份证'
						},
						{
							value: '工牌'
						},
						{
							value: '军官证'
						},
						{
							value: '其他证件'
						},
						{
							value: '学生证'
						},
					],
					showDrawerUser: false,
					suiteIndex: 0,
					noData: false,
					showPrompt:false,
					promptContent:"内容"
				},
				userList: [],
				model: {
				},
				ruleValidate: {
					PatientName: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					IDCardType: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					IDCardNo: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					PatientPhone: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					Sex: [{
						required: true,
						message: '不能为空',
						trigger: 'blur'
					}],
					Birthday: [{
						required: true,
						type: 'date',
						message: '不能为空',
						trigger: 'change'
					}],
				}
			};
		},
		mounted() {
			this.init();
			this.user();
		},
		methods: {
			init() {
				var token = getToken();
				if (token) this.view.promptContent = token.viewPromptContent;
				var registerNumberStr = this.$route.query.registerNumber;
				if (!this.isNullOrEmptyEx(registerNumberStr)) {
					var registerNumber = JSON.parse(registerNumberStr)
					this.model = {
						RegisterNumber: registerNumber.id,
						RegisterDate: registerNumber.registerDate,
						RegisterTime: registerNumber.registerTime,
					};
				} else this.view.noData = true;
			},
			user() {
				var that = this;
				sysPost(that, {
					"url": 'Inspect/UserList',
					"data": {}
				}, function(result) {
					that.userList = result;
				})
			},
			showDrawerUser() {
				this.view.showDrawerUser = true;
			},
			userCheck(item) {
				this.model.PatientName = item.patientName;
				this.model.IDCardType = item.idCardType;
				this.model.IDCardNo = item.idCardNo;
				this.model.PatientPhone = item.patientPhone;
				this.model.Sex = item.sex;
				this.model.Birthday = this.converterEx.toDateString(item.birthday);
				this.view.showDrawerUser = false;
			},
			confirm() {
				this.$refs['form'].validate((valid) => {
					if (valid) this.view.showPrompt=true;
				})
			},
			post(){
				var that = this;
				sysPost(that, {
					"url": 'Register/Add',
					"data": {
						"RegisterNumber": that.model.RegisterNumber,
						"PatientName": that.model.PatientName,
						"IDCardType": that.model.IDCardType,
						"IDCardNo": that.model.IDCardNo,
						"PatientPhone": that.model.PatientPhone,
						"Sex": that.model.Sex,
						"Birthday": that.model.Birthday,
						"Consultant": that.model.Consultant,
						//"Age": that.model.Age,
					}
				}, function(result) {
					that.$Message.success('预约成功！');
					that.$router.push("/registerIndex")
				});
			},
		},
		components: {
			"v-header": header
		}
	}
</script>
